import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=75797619&"
import script from "./CertificateForm.vue?vue&type=script&lang=js&"
export * from "./CertificateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports